import React from "react";
import Navbar from "@/components/Navbar";
import { useAuth } from "@/contexts/AuthContext";
import { VIEWER_ROLES } from "@/lib/constants";
import { FileDown } from "lucide-react";

const STAFF_ROLES = ["admin", "pi", "acp", "dcp", "additional_cp", "control_room",
  "municipal_commissioner", "divisional_commissioner", "collector", "commissioner_of_police"];

export default function Layout({ children }) {
  const { user } = useAuth();
  let links = [];
  if (!user) {
    links = [
      { key: "home", to: "/", label: "Home" },
      { key: "track", to: "/track", label: "Track Complaint" },
    ];
  } else if (user.role === "citizen") {
    links = [
      { key: "my-complaints", to: "/citizen", label: "My Complaints" },
      { key: "new-complaint", to: "/citizen/new", label: "File Complaint" },
      { key: "track", to: "/track", label: "Track" },
    ];
  } else if (user.role === "pi") {
    links = [
      { key: "assigned", to: "/pi", label: "Station Complaints" },
    ];
  } else if (user.role === "acp") {
    links = [
      { key: "escalated", to: "/acp", label: "Escalated to me" },
    ];
  } else if (user.role === "dcp") {
    links = [
      { key: "escalated", to: "/dcp", label: "Escalated to DCP" },
      { key: "dashboard", to: "/dashboard", label: "Dashboard" },
      { key: "reports", to: "/reports", label: "Reports" },
    ];
  } else if (user.role === "additional_cp") {
    links = [
      { key: "escalated", to: "/additional-cp", label: "All escalations" },
      { key: "dashboard", to: "/dashboard", label: "Dashboard" },
      { key: "reports", to: "/reports", label: "Reports" },
    ];
  } else if (user.role === "control_room") {
    links = [
      { key: "control", to: "/control-room", label: "Control Room" },
      { key: "register", to: "/control-room/register", label: "Register" },
      { key: "dashboard", to: "/dashboard", label: "Dashboard" },
    ];
  } else if (VIEWER_ROLES.includes(user.role)) {
    links = [
      { key: "dashboard", to: "/dashboard", label: "Dashboard" },
      { key: "reports", to: "/reports", label: "Reports" },
    ];
    if (user.role === "admin") {
      links.push({ key: "admin", to: "/admin", label: "Admin" });
    }
  }
  const isStaff = user && STAFF_ROLES.includes(user.role);
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar links={links} />
      <main className="flex-1">{children}</main>
      {isStaff && (
        <footer className="border-t border-border/60 bg-slate-50/60 mt-10" data-testid="staff-manual-footer">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
            <div className="text-xs uppercase tracking-wider text-slate-500 font-medium">Employee User Manual</div>
            <div className="flex flex-wrap gap-2">
              <a
                href="/nagpur-noise-manual-marathi.pdf"
                target="_blank"
                rel="noreferrer"
                data-testid="staff-manual-mr-btn"
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-border bg-white text-sm font-medium text-slate-700 hover:border-slate-400 hover:text-slate-900 transition-colors"
              >
                <FileDown className="w-4 h-4" /> मराठी कर्मचारी नियमपुस्तिका (PDF)
              </a>
              <a
                href="/nagpur-noise-manual-english.pdf"
                target="_blank"
                rel="noreferrer"
                data-testid="staff-manual-en-btn"
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-border bg-white text-sm font-medium text-slate-700 hover:border-slate-400 hover:text-slate-900 transition-colors"
              >
                <FileDown className="w-4 h-4" /> English Employee Manual (PDF)
              </a>
            </div>
            <div className="sm:ml-auto text-[11px] text-slate-500">
              Reference guide for {"\u00A0"}PI · ACP · DCP · Additional CP · Admin roles.
            </div>
          </div>
        </footer>
      )}
    </div>
  );
}
